// src/api/invoiceTemplateApi.js
import axiosClient from "./axiosClient";

const invoiceTemplateApi = {
  searchTemplates: (cusId, keyword, page, pageSize) => {
    const params = new URLSearchParams();
    params.append("cusId", cusId);
    params.append("searchKeyword", keyword);
    params.append("pageNumber", page > 0 ? page + 1 : 1);
    params.append("pageSize", pageSize);

    return axiosClient.get(`/invoice_templates/search?${params.toString()}`, {
      withCredentials: true,
    });
  },
  LoadDefaultInvoiceTemplate: () => {
    return axiosClient.get("/invoice_templates/load-default-invoice-template", {
      withCredentials: true,
    });
  },
  GetInvoiceTemplateActive: (reiId) => {
    return axiosClient.post(
      "/invoice_templates/get-active",
      {
        reiId: reiId,
      },
      {
        withCredentials: true,
      },
    );
  },
  upsertTemplate: (templateData, imageLogo) => {
    const formData = new FormData();
    Object.entries(templateData).forEach(([key, value]) => {
      formData.append(key, value);
    });
    if (imageLogo) {
      formData.append("imageLogo", imageLogo);
    }
    return axiosClient.post("/invoice_templates/upsert", formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  ReplaceInvoiceTemplate: (templateData, imageLogo) => {
    const formData = new FormData();
    Object.entries(templateData).forEach(([key, value]) => {
      formData.append(key, value);
    });
    if (imageLogo) {
      formData.append("imageLogo", imageLogo);
    }
    return axiosClient.post("/invoice_templates/replace", formData, {
      withCredentials: true,
    });
  },
  deleteTemplate: (ItId) => {
    return axiosClient.delete(`/invoice_templates/${ItId}`, {
      withCredentials: true,
    });
  },
  unActiveTemplate: (ItId) => {
    return axiosClient.put(
      `/invoice_templates/${ItId}`,
      {},
      {
        withCredentials: true,
      },
    );
  },
  handleAddNewYearInvoiceTemplate: () => {
    return axiosClient.post(
      "/invoice_templates/handle-add-new-year-invoice-template",
      {},
      {
        withCredentials: true,
      },
    );
  },
};

export default invoiceTemplateApi;
